import React from "react";
import Section from "./Section";
import Reveal from "./Reveal";
import { experience } from "../data";

function Experience() {
  return (
    <Section id="experience" title="Professional" accent="Experience">
      <div className="timeline">
        {experience.map((e, i) => (
          <Reveal as="article" dir={i % 2 ? "right" : "left"} key={e.company + e.role} className="timeline-item card">
            <div className="timeline-head">
              <div>
                <h3>{e.role}</h3>
                <p className="company">{e.company} · {e.place}</p>
              </div>
              <span className="period">{e.period}</span>
            </div>
            {e.intro && <p className="muted">{e.intro}</p>}
            <ul className="bullets">
              {e.points.map((p) => <li key={p}>{p}</li>)}
            </ul>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

export default Experience;
